// Thursday pickup time picker in the bag (snippets/saintcha-pickup-slot.liquid). The shopper enters any time
// from 10:00 am to 8:00 pm (native time input). Saves cart attributes "Delivery", "Pickup date", "Pickup time"
// (e.g. "2:45 pm") via /cart/update.js and holds checkout until a valid time is entered.
(function () {
  if (window.__scPickup) return; window.__scPickup = true;
  var TZ = 'America/Los_Angeles', MIN = 600, MAX = 1200;
  var MSG_EMPTY = 'Choose a pickup time to check out.', MSG_RANGE = 'Please choose a time between 10 am and 8 pm';
  function toMinutes(v) { var m = /^(\d{1,2}):(\d{2})/.exec(v || ''); return m ? (+m[1]) * 60 + (+m[2]) : NaN; }
  function label(mins) { var h = Math.floor(mins / 60), mm = mins % 60; return (h % 12 || 12) + ':' + (mm < 10 ? '0' : '') + mm + ' ' + (h < 12 ? 'am' : 'pm'); }
  function fromLabel(t) {
    var m = /^(\d{1,2}):(\d{2})\s*(am|pm)$/i.exec(t || ''); if (!m) return '';
    var h = (+m[1]) % 12 + (m[3].toLowerCase() === 'pm' ? 12 : 0);
    return (h < 10 ? '0' : '') + h + ':' + m[2];
  }
  function pickupDate() {
    var p = {}; new Intl.DateTimeFormat('en-US', { timeZone: TZ, weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
      .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    var dow = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday);
    var diff = (4 - dow + 7) % 7; if (diff === 0 && +p.hour >= 16) diff = 7;
    var d = new Date(Date.UTC(+p.year, +p.month - 1, +p.day + diff, 12));
    return d.toLocaleDateString('en-US', { timeZone: 'UTC', weekday: 'long', month: 'short', day: 'numeric' });
  }
  var state = null; // {mode, time ("2:45 pm" or ""), raw ("14:45"), date}
  var timer = null;
  function save(attrs) {
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) }).catch(function () {});
  }
  function scope(el) { return el.closest('.bag-page__aside, .bag-drawer__foot') || document; }
  function render(el, skipInput) {
    var pickup = state.mode === 'pickup';
    el.classList.toggle('is-pickup', pickup);
    el.querySelectorAll('[data-pickup-mode]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-pickup-mode') === state.mode)); });
    var pick = el.querySelector('[data-pickup-pick]'); if (pick) pick.hidden = !pickup;
    var dt = el.querySelector('[data-pickup-date]'); if (dt) dt.textContent = state.date;
    var inp = el.querySelector('[data-pickup-time]');
    var invalid = !!state.raw && !state.time;
    if (inp) {
      if (inp !== skipInput && inp.value !== state.raw) inp.value = state.raw;
      inp.setAttribute('aria-invalid', String(invalid));
    }
    var blocked = pickup && !state.time;
    var sc = scope(el);
    sc.querySelectorAll('.bag-checkout button[name="checkout"]').forEach(function (btn) {
      if (btn.hasAttribute('disabled') && !btn.hasAttribute('data-pickup-block')) return; // held by stock / empty bag
      if (blocked) { btn.disabled = true; btn.setAttribute('data-pickup-block', ''); }
      else if (btn.hasAttribute('data-pickup-block')) { btn.disabled = false; btn.removeAttribute('data-pickup-block'); }
    });
    sc.querySelectorAll('[data-bag-pay]').forEach(function (p) { p.classList.toggle('is-pickup-hidden', pickup); });
    var err = el.querySelector('[data-pickup-err]');
    if (err) { err.hidden = !blocked; err.textContent = invalid ? MSG_RANGE : MSG_EMPTY; }
  }
  function renderAll(skipInput) { document.querySelectorAll('[data-pickup-slot]').forEach(function (el) { render(el, skipInput); }); }
  function init(el) {
    if (el.__scInit) return; el.__scInit = true;
    if (!state) {
      var t = el.getAttribute('data-time') || '';
      state = { mode: el.getAttribute('data-mode') || 'shipping', time: t, raw: fromLabel(t), date: pickupDate() };
      if (!state.raw) state.time = '';
      var saved = el.getAttribute('data-date') || '';
      if (state.mode === 'pickup' && saved !== state.date) { if (saved) { state.time = ''; state.raw = ''; } save({ 'Pickup date': state.date, 'Pickup time': state.time }); }
    }
    render(el);
  }
  function scan() { document.querySelectorAll('[data-pickup-slot]').forEach(init); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pickup-mode]'); if (!b) return;
    var mode = b.getAttribute('data-pickup-mode'); if (!state || state.mode === mode) return;
    state.mode = mode;
    if (mode === 'shipping') { state.time = ''; state.raw = ''; save({ Delivery: 'Shipping', 'Pickup date': '', 'Pickup time': '' }); }
    else save({ Delivery: 'Local pickup', 'Pickup date': state.date });
    renderAll();
  });
  function onTime(e) {
    var inp = e.target.closest && e.target.closest('[data-pickup-time]'); if (!inp || !state) return;
    var mins = toMinutes(inp.value);
    state.raw = inp.value;
    state.time = (!isNaN(mins) && mins >= MIN && mins <= MAX) ? label(mins) : '';
    renderAll(inp);
    clearTimeout(timer);
    timer = setTimeout(function () { save({ Delivery: 'Local pickup', 'Pickup date': state.date, 'Pickup time': state.time }); }, e.type === 'change' ? 0 : 400);
  }
  document.addEventListener('input', onTime);
  document.addEventListener('change', onTime);
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f.classList || !f.classList.contains('bag-checkout') || !state) return;
    if (state.mode === 'pickup' && !state.time) {
      e.preventDefault(); e.stopPropagation();
      var el = scope(f).querySelector('[data-pickup-slot]');
      if (el) { var err = el.querySelector('[data-pickup-err]'); if (err) err.hidden = false; var s = el.querySelector('[data-pickup-time]'); if (s) s.focus(); }
    }
  }, true);
  new MutationObserver(function () { scan(); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
})();
